import {addCustomEventDataLayer, processComponent} from "../analytics/utils";

document.addEventListener('DOMContentLoaded', function () {
    const searchForm = document.querySelector('#header-search');
    const searchInput = document.querySelector('#searchInput');
    const solrApiBaseUrlElement = document.querySelector('#solrApiBaseUrl');
    const solrApiSiteNameElement = document.querySelector('#solrApiSiteName');
    const searchListItemElement = document.querySelector('#searchListItem');
    const baseUrl = solrApiBaseUrlElement ? solrApiBaseUrlElement.value.trim() : null;
    const siteName = solrApiSiteNameElement ? solrApiSiteNameElement.value.trim() : null;
    const pageSize = searchListItemElement ? searchListItemElement.value.trim() : '10';
    const resultsContainer = document.querySelector('#searchResultsList');
    const paginationContainer = document.querySelector('#paginationList');
    const noResultsMessage = document.querySelector('#noResultsMessage');
    const PAGE_PARAM_KEY = 'page';
    const DOC_TYPE_PARAM_KEY = 'doc_type';
    const PAGE_DEFAULT = '1';
    const DOC_TYPE_DEFAULT = 'page';
    const dataLayerComponentId = document.querySelector('.csh-aem-base-search-results');


    if (!searchForm || !resultsContainer) {
        console.error('Critical elements missing');
        return;
    }

    if (!baseUrl || !siteName) {
        if (resultsContainer) {
            console.error('Solr API base URL or site name not found');
        }
        return;
    }

    function fetchSearchResults(query, baseUrl, siteName, page) {
        try {
            const encodedQuery = encodeURIComponent(query);
            const apiUrl = new URL(baseUrl);

            apiUrl.searchParams.set('site', siteName);
            apiUrl.searchParams.set(PAGE_PARAM_KEY, page);
            apiUrl.searchParams.set(DOC_TYPE_PARAM_KEY, DOC_TYPE_DEFAULT);
            apiUrl.searchParams.set('queryDetails', encodedQuery);
            apiUrl.searchParams.set('pageSize', pageSize);

            console.log('Fetching URL:', apiUrl.toString());

            fetch(apiUrl.toString(), {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            })
                .then(response => handleResponse(response))
                .then(json => handleData(json, page))
                .catch(error => handleError(error));
        } catch (error) {
            console.error('Error constructing the API URL:', error.message);
            noResultsFound();
        }
    }

    function handleResponse(response) {
        if (!response.ok) {
            return response.text().then(text => {
                throw new Error(`HTTP error! Status: ${response.status}, Response body: ${text}`);
            });
        }
        return response.json();
    }

    function handleData(data, page) {
        if (!resultsContainer || !paginationContainer) {
            console.error('Results container or pagination element not found');
            return;
        }

        resultsContainer.innerHTML = '';
        paginationContainer.innerHTML = '';

        if (data.response && data.response.docs && data.response.numFound > 0) {
            const resultsToShow = data.response.docs;
            resultsToShow.forEach(result => {
                const item = document.createElement('li');
                item.className = 'csh-aem-base-search-results__item';
                item.innerHTML = `
                    <h3 class="csh-aem-base-search-results__title"><a class="csh-aem-base-search-results__title" href="${result?.url || '#'}">${result?.title?.[0] || 'No Title'}</a></h3>
                    <p class="csh-aem-base-search-results__description">${result?.content?.[0] || 'No Description'}</p>
                `;
                resultsContainer.appendChild(item);
            });
            createPagination(data.response.numFound, page);
            searchLinkListener();
        } else {
            noResultsFound();
        }
    }

    function createPagination(totalResults, currentPage) {
        console.log('Creating Pagination: Total Results:', totalResults, 'Current Page:', currentPage);
        if(currentPage === 1){
            addCustomEventDataLayer(dataLayerComponentId,'site_search_results',{siteSearchResultTerm: urlParams.get('queryDetails'),
                siteSearchResultCount: totalResults})
        }

        const totalPages = Math.ceil(totalResults / pageSize);
        paginationContainer.innerHTML = '';

        const createPageItem = (pageNum, label = pageNum) => {
            const item = document.createElement('li');
            item.className = 'csh-aem-base-search-results-pagination__item';

            const link = document.createElement('a');
            link.href = `?${PAGE_PARAM_KEY}=${pageNum}&queryDetails=${encodeURIComponent(urlParams.get('queryDetails'))}`;
            link.className = 'csh-aem-base-search-results-pagination__link';

            if (pageNum === currentPage) {
                link.classList.add('active');
            }
            link.textContent = label;

            link.addEventListener('click', function (event) {
                event.preventDefault();
                const newPage = pageNum;
                console.log('Pagination Link Clicked:', newPage);
                window.history.pushState({ page: newPage, queryDetails: urlParams.get('queryDetails') }, '', `?${PAGE_PARAM_KEY}=${newPage}&queryDetails=${encodeURIComponent(urlParams.get('queryDetails'))}`);
                fetchSearchResults(urlParams.get('queryDetails'), baseUrl, siteName, newPage);
            });

            item.appendChild(link);
            return item;
        };

        if (currentPage > 1) {
            paginationContainer.appendChild(createPageItem(currentPage - 1, '<'));
        }

        for (let i = 1; i <= totalPages; i++) {
            paginationContainer.appendChild(createPageItem(i));
        }

        if (currentPage < totalPages) {
            paginationContainer.appendChild(createPageItem(currentPage + 1, '>'));
        }
    }

    function handleError(error) {
        console.error('Error fetching search results:', error.message);
        noResultsFound();
    }

    function noResultsFound() {
        addCustomEventDataLayer(dataLayerComponentId,'site_search_results',{siteSearchResultTerm: urlParams.get('queryDetails'),
            siteSearchResultCount: "Zero Results Found"})
        if (noResultsMessage) {
            noResultsMessage.style.display = 'block';
        }
    }

    function updatePageFromState() {
        const urlParams = new URLSearchParams(window.location.search);
        const queryDetails = urlParams.get('queryDetails') || '';
        const page = parseInt(urlParams.get(PAGE_PARAM_KEY)) || 1;

        console.log('Updating Page from State: Query Details:', queryDetails, 'Page:', page);

        if (queryDetails) {
            fetchSearchResults(queryDetails, baseUrl, siteName, page);
        } else {
            noResultsFound();
        }
    }

    const urlParams = new URLSearchParams(window.location.search);
    const queryDetails = urlParams.get('queryDetails') || '';
    const page = parseInt(urlParams.get(PAGE_PARAM_KEY)) || 1;
    console.log('page', page);

    if (queryDetails) {
        fetchSearchResults(queryDetails, baseUrl, siteName, page);
    } else if (resultsContainer) {
        noResultsFound();
    }
    searchForm.addEventListener('submit', function (event) {
        event.preventDefault();
        const query = searchInput.value.trim();
        if (query) {
            const page = 1; 
            fetchSearchResults(query, baseUrl, siteName, page);
            window.history.pushState({ page: page, queryDetails: query }, '', `?${PAGE_PARAM_KEY}=${page}&queryDetails=${encodeURIComponent(query)}`);
        }
    });

    window.addEventListener('popstate', function (event) {
        console.log('Popstate Event:', event.state);
        updatePageFromState();
    });

    function searchLinkListener() {
        const searchComponents = document.querySelectorAll('.csh-aem-base-search-results');
        searchComponents.forEach( processComponent );
    }
});
